import { toBinanceInterval } from "../../candle-intervals";
import { normalizeCandleSymbol } from "../../candle-symbols";
import {
  CandleInterval,
  ExchangeCandleWsAdapter,
} from "../../candle.types";
import { RECONNECT_DELAYS_MS } from "./ws-candle.utils";

interface BinanceWsKline {
  t: number;
  o: string;
  h: string;
  l: string;
  c: string;
  v: string;
}

interface BinanceWsMessage {
  e: "kline";
  E: number;
  s: string;
  k: BinanceWsKline;
}

function wsInterval(interval: CandleInterval): string {
  return toBinanceInterval(interval);
}

export const binanceCandlesWsAdapter: ExchangeCandleWsAdapter = {
  subscribe(symbol, interval, onUpdate, onError) {
    const normalized = normalizeCandleSymbol("binance", symbol);
    const stream = `${normalized.toLowerCase()}@kline_${wsInterval(interval)}`;

    let ws: WebSocket | null = null;
    let attempt = 0;
    let stopped = false;

    const connect = () => {
      if (stopped) return;
      ws = new WebSocket(`wss://fstream.binance.com/ws/${stream}`);

      ws.onmessage = (event: MessageEvent<string>) => {
        try {
          const data = JSON.parse(event.data) as BinanceWsMessage;
          if (!data.k) return;
          onUpdate({
            symbol: normalized,
            exchange: "binance",
            interval,
            candle: {
              startTime: data.k.t,
              openPrice: data.k.o,
              highPrice: data.k.h,
              lowPrice: data.k.l,
              closePrice: data.k.c,
              volume: data.k.v,
            },
            timestamp: data.E,
          });
          attempt = 0;
        } catch {
          // Ignore malformed payloads
        }
      };

      ws.onerror = () => {
        // onclose handles retries
      };

      ws.onclose = () => {
        if (stopped) return;
        const delay =
          RECONNECT_DELAYS_MS[
            Math.min(attempt, RECONNECT_DELAYS_MS.length - 1)
          ];
        attempt += 1;
        if (attempt > RECONNECT_DELAYS_MS.length) {
          onError?.(new Error(`binance: live candle stream disconnected`));
          return;
        }
        setTimeout(connect, delay);
      };
    };

    connect();

    return () => {
      stopped = true;
      ws?.close();
      ws = null;
    };
  },
};

